import apiService from './api.service'

export const BASE_PATH = '/lottustech/agendamentosrelatorio'

/** { campo: formula } -> { campo: { data: 'yyyy-MM-dd' } | { erro: '...' } }, calculado para hoje. */
const resolverDatas = (formulas) => apiService.post(`${BASE_PATH}/resolver-datas`, formulas)

/** URL do relatorio em HTML com as datas de hoje; nao envia e-mail. Serve antes de salvar. */
const visualizar = (agendamento) => apiService.post(`${BASE_PATH}/preview`, agendamento)

const salvar = (agendamento) =>
  agendamento.oid
    ? apiService.put(`${BASE_PATH}/${agendamento.oid}`, agendamento)
    : apiService.post(`${BASE_PATH}/`, agendamento)

/** Agendamento completo (o da listagem vem com a projecao reduzida). */
const carregar = (oid) => apiService.get(`${BASE_PATH}/${oid}`)

// FILTROS SALVOS (PHOENIX-107): dono, empresa e unidade do topo vem do login e dos cabecalhos
const CONJUNTOS = `${BASE_PATH}/conjuntos`

/** Perfis do usuario logado: [{ id, value }]. */
const perfisConjunto = () => apiService.get(`${CONJUNTOS}/perfis`)

/** { path, oidDocumento, index, max } -> { count, records: [conjunto] } */
const pesquisarConjuntos = (pesquisa) => apiService.post(`${CONJUNTOS}/pesquisa`, pesquisa)

const salvarConjunto = (conjunto) =>
  conjunto.oid ? apiService.put(`${CONJUNTOS}/${conjunto.oid}`, conjunto) : apiService.post(CONJUNTOS, conjunto)

const excluirConjunto = (oid) => apiService.remove(`${CONJUNTOS}/${oid}`)

const marcarPadraoConjunto = (oid, padrao) =>
  padrao ? apiService.put(`${CONJUNTOS}/${oid}/padrao`) : apiService.remove(`${CONJUNTOS}/${oid}/padrao`)

/** URL do relatorio com o filtro salvo e as datas de hoje, como o usuario logado. */
const executarConjunto = (oid) => apiService.post(`${CONJUNTOS}/${oid}/executar`)

/** O filtro padrao do usuario no relatorio (R3/R4 no back), para abrir a tela preenchida; 204 sem padrao. */
const padraoConjunto = ({ path, oidDocumento }) => {
  const parametros = new URLSearchParams({ path })
  if (oidDocumento) {
    parametros.append('oidDocumento', oidDocumento)
  }
  return apiService.get(`${CONJUNTOS}/padrao?${parametros.toString()}`)
}

export {
  resolverDatas,
  visualizar,
  salvar,
  carregar,
  perfisConjunto,
  pesquisarConjuntos,
  salvarConjunto,
  excluirConjunto,
  marcarPadraoConjunto,
  executarConjunto,
  padraoConjunto,
}
